import Box from '@elementor/ui/Box';
import Typography from '@elementor/ui/Typography';
import { ErrorImage } from '@images';
import { StyledStateContainer } from '@styles/app.styles';
import { __ } from '@utils/i18n';

const HeadingStructureHeadingTreeEmpty = () => {
	return (
		<StyledStateContainer>
			<ErrorImage />

			<Box sx={{ maxWidth: '300px' }}>
				<Typography variant="h5" align="center" sx={{ mb: 2 }}>
					{__('No headings found')}
				</Typography>

				<Typography variant="body2" align="center">
					{__(
						'Each page should have a main heading (H1) to establish proper structure and help users understand the page content.',
					)}
				</Typography>
			</Box>
		</StyledStateContainer>
	);
};

export default HeadingStructureHeadingTreeEmpty;
